import React, { FC } from 'react'

export const Helpdesk: FC = () => {
  // useEffect(() => {
  //   // TODO handle CORS errors
  //   const myIFrame = document.getElementById('helpdeskIframe');
  //   myIFrame.onload = function () {
  //     const myIFrame = document.getElementById('helpdeskIframe');
  //     myIFrame['contentWindow'].document.body.innerHTML =
  //       '<style>header {display: none;}</style>' + myIFrame['contentWindow'].document.body.innerHTML;
  //   };
  // }, []);
  return (
    // <iframe
    //   id="helpdeskIframe"
    //   src="https://powcloud.freshdesk.com/support/home"
    //   style={{ height: '100%', width: '100%' }}
    //   title="Helpdesk"
    // />
    <div></div>
  )
}
